/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelFromJSONTyped,
    BasicModelToJSON,
} from './BasicModel';
import {
    OfferFormBidAttachmentViewModel,
    OfferFormBidAttachmentViewModelFromJSON,
    OfferFormBidAttachmentViewModelFromJSONTyped,
    OfferFormBidAttachmentViewModelToJSON,
} from './OfferFormBidAttachmentViewModel';

/**
 * 
 * @export
 * @interface OfferFormRenterBidViewModel
 */
export interface OfferFormRenterBidViewModel {
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    bid?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    advancePayment?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    renterPeriodPayment?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OfferFormRenterBidViewModel
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OfferFormRenterBidViewModel
     */
    paymentLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    shippingToBackFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    machineGoCommission?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    predictedTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    shippingFeeWithCommission?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterBidViewModel
     */
    shippingToBackFeeWithCommission?: number | null;
    /**
     * 
     * @type {BasicModel}
     * @memberof OfferFormRenterBidViewModel
     */
    currency?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof OfferFormRenterBidViewModel
     */
    maturityOption?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof OfferFormRenterBidViewModel
     */
    paymentPeriod?: BasicModel;
    /**
     * 
     * @type {Array<OfferFormBidAttachmentViewModel>}
     * @memberof OfferFormRenterBidViewModel
     */
    attachments?: Array<OfferFormBidAttachmentViewModel> | null;
}

export function OfferFormRenterBidViewModelFromJSON(json: any): OfferFormRenterBidViewModel {
    return OfferFormRenterBidViewModelFromJSONTyped(json, false);
}

export function OfferFormRenterBidViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferFormRenterBidViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'bid': !exists(json, 'bid') ? undefined : json['bid'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'advancePayment': !exists(json, 'advancePayment') ? undefined : json['advancePayment'],
        'renterPeriodPayment': !exists(json, 'renterPeriodPayment') ? undefined : json['renterPeriodPayment'],
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
        'paymentLink': !exists(json, 'paymentLink') ? undefined : json['paymentLink'],
        'shippingFee': !exists(json, 'shippingFee') ? undefined : json['shippingFee'],
        'shippingToBackFee': !exists(json, 'shippingToBackFee') ? undefined : json['shippingToBackFee'],
        'machineGoCommission': !exists(json, 'machineGoCommission') ? undefined : json['machineGoCommission'],
        'predictedTotal': !exists(json, 'predictedTotal') ? undefined : json['predictedTotal'],
        'shippingFeeWithCommission': !exists(json, 'shippingFeeWithCommission') ? undefined : json['shippingFeeWithCommission'],
        'shippingToBackFeeWithCommission': !exists(json, 'shippingToBackFeeWithCommission') ? undefined : json['shippingToBackFeeWithCommission'],
        'currency': !exists(json, 'currency') ? undefined : BasicModelFromJSON(json['currency']),
        'maturityOption': !exists(json, 'maturityOption') ? undefined : BasicModelFromJSON(json['maturityOption']),
        'paymentPeriod': !exists(json, 'paymentPeriod') ? undefined : BasicModelFromJSON(json['paymentPeriod']),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(OfferFormBidAttachmentViewModelFromJSON)),
    };
}

export function OfferFormRenterBidViewModelToJSON(value?: OfferFormRenterBidViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'bid': value.bid,
        'total': value.total,
        'advancePayment': value.advancePayment,
        'renterPeriodPayment': value.renterPeriodPayment,
        'selected': value.selected,
        'paymentLink': value.paymentLink,
        'shippingFee': value.shippingFee,
        'shippingToBackFee': value.shippingToBackFee,
        'machineGoCommission': value.machineGoCommission,
        'predictedTotal': value.predictedTotal,
        'shippingFeeWithCommission': value.shippingFeeWithCommission,
        'shippingToBackFeeWithCommission': value.shippingToBackFeeWithCommission,
        'currency': BasicModelToJSON(value.currency),
        'maturityOption': BasicModelToJSON(value.maturityOption),
        'paymentPeriod': BasicModelToJSON(value.paymentPeriod),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(OfferFormBidAttachmentViewModelToJSON)),
    };
}

